import appsCollector from './AppsCollector/AppsCollector';
import App from '@/Common/Runtime/AppsCollector/App';
import i18nServiceModule from '@/HostApp/services/I18nService/I18nServiceModule';

const SUFIX_MAIN_CONTAINER = '-main-container';
const EXT_COMPONENT_SCRIPT = '.js';

let baseApiUrl = '';
let baseStylesheetUrls: string[] = [];

// TODO May be dont need
export const setBaseUrl = (url: string): void => {
	baseApiUrl = url;
};

export const getBaseUrl = (): string => {
	return baseApiUrl;
};

export const setStylesheetUrls = (stylesheetUrls: string[]): void => {
	baseStylesheetUrls = stylesheetUrls;
};
//===

export const loadScript = (url: string): Promise<void> => {
	return new Promise((resolve, reject) => {
		const script: HTMLScriptElement = document.createElement('script');

		script.type = 'text/javascript';
		script.onload = (): void => resolve();
		script.onerror = reject;
		script.src = url;
		document.getElementsByTagName('head')[0].appendChild(script);
	});
};

export const getWCData = ({ url, appId, parent }: Host.IInputWCData): Host.IWCData => {
	const appName = url.replace(EXT_COMPONENT_SCRIPT, '').split('/').pop() || '';
	const wcData: Host.IWCData = { el: null, url };

	if (appName) {
		const componentName = appName.toLowerCase() + SUFIX_MAIN_CONTAINER;
		const el = document.createElement(componentName) as Host.WCElement;

		el.setAttribute('id', appId);
		parent.append(el);

		wcData.el = el;
	}

	return wcData;
};

export const createInstanceApp = async ({
	url,
	appId,
	parent,
	options = {},
	devMode = false
}: Host.ICreateInstanceAppParams): Promise<App | never> => {
	const { packageId } = options as Host.IOptionsCreateApp;
	const { el, url: urlWC } = getWCData({ url, appId, parent });
	const urlApp = `${urlWC.replace(EXT_COMPONENT_SCRIPT, '')}${!devMode ? '.min' : ''}${EXT_COMPONENT_SCRIPT}`;

	if (el) {
		const script = loadScript(urlApp);
		const translations = i18nServiceModule.loadPackageTranslations(packageId);

		el.setAttribute('packageId', packageId);

		const ready = new Promise((resolve) => {
			el.addEventListener('ready', resolve);
		});

		await Promise.all([script, ready]);

		const { stylesheetUrls = [] } = options;
		const mergedStylesheetUrls = [...baseStylesheetUrls, ...stylesheetUrls];
		const newOptions = { ...options, baseApiUrl, stylesheetUrls: mergedStylesheetUrls };

		(el.vueComponent as App.IMainContainer).setOptions(newOptions);

		await translations;
		return appsCollector.add(el.id, el);
	} else {
		throw new Error('Cannot create vue application. Element not found.');
	}
};

export const getApps = (): Common.IMap<App> => appsCollector.getApps();
export const getApp = (name: string): App | null => appsCollector.getApp(name);
